import React, { useRef } from 'react';

const MagneticButton = ({
  href = null, // Changed default to null
  children = "Let's Talk!",
  className = '',
  iconClass = 'bi bi-arrow-right ms-1',
  type = "button", // Added type prop
  onClick // Added onClick prop
}) => {
  const spanRef = useRef(null);

  const updatePosition = (e) => {
    const button = e.currentTarget;
    const rect = button.getBoundingClientRect();
    const parentOffsetLeft = rect.left + window.scrollX;
    const parentOffsetTop = rect.top + window.scrollY;
    const relX = e.pageX - parentOffsetLeft;
    const relY = e.pageY - parentOffsetTop;

    if (spanRef.current) {
      spanRef.current.style.top = `${relY}px`;
      spanRef.current.style.left = `${relX}px`;
    }
  };

  // If href is provided, render <a>, otherwise render <button>
  const Component = href ? 'a' : 'button';

  return (
    <Component
      href={href}
      type={!href ? type : undefined}
      className={`btn magnetic-button ${className}`}
      onMouseEnter={updatePosition}
      onMouseLeave={updatePosition}
      onClick={onClick}
    >
      {children}
      <i className={`icon ${iconClass}`} />
      <span ref={spanRef} />
    </Component>
  );
};

export default MagneticButton;